import React, { useState, useEffect, useContext, useRef } from 'react';
import './Type2.scss';
import '../ComponentGallery/Type2.scss';
import '../ComponentGallery/Type3.scss';

import { direct } from '../../utils/image';
// wx_gallery_mode_2
import { IVideoListItem } from './AllForHVideoList';
import StatusTag from '../Tag/StatusTag';
import { ThemeContext } from '../../store/ThemeProvider';
import { IGalleryStatus } from '../../global.d';
import chroma from 'chroma-js';
import intl from 'react-intl-universal';
import { getPendantColor } from '../../utils/color';
import { resolveLocaleText } from '../../utils/localeText';

export default (props: IVideoListItem) => {
  const { h1Color, mainColor } = useContext(ThemeContext);
  let {
    id,
    onClick,
    thumb,
    desc,
    source_detail,
    type,
    view,
    uv,
    status,
    info,
    componentData
  } = props;
  if (componentData && componentData.image) {
    thumb = componentData.image;
  }
  const customDesc = resolveLocaleText(
    componentData && (componentData.desc || componentData.link?.desc),
    componentData && (componentData.desc_i18n || componentData.link?.desc_i18n)
  );
  if (customDesc) {
    desc = customDesc;
  }
  if (source_detail && type == 'live') {
    if (!thumb) {
      thumb = source_detail.cover_img;
    }
    if (!customDesc) {
      desc = source_detail.title;
    }
    status = source_detail.status;
  }

  const [bgColor, foreColor] = getPendantColor(mainColor);

  const typeRef = useRef<any>(null);

  const [width, setWidth] = useState(0);
  const [height, setHeight] = useState(0);

  useEffect(() => {
    if (typeRef && typeRef.current) {
      setWidth(Math.floor(typeRef.current.clientWidth - 10));
      setHeight((Math.floor(typeRef.current.clientWidth - 10) * 2) / 3);
    }
  }, [typeRef]);

  const cns = 'type-wrapper type3-wrapper type2-wrapper';

  return (
    <div className="type2-outer" ref={typeRef}>
      <div
        className={cns}
        style={width && height ? { width, height } : {}}
        onClick={onClick}
      >
        <div className="main">
          <div className="content">
            <img
              className="content-img"
              src={direct(thumb, 'wx_gallery_mode_2')}
            />
            <div className="content-one">
              {info ? (
                <StatusTag
                  status={status as IGalleryStatus}
                  className={'status'}
                  invert={false}
                  fontSize={12}
                />
              ) : null}
              {info ? (
                <div
                  className="bottom-row"
                  style={{ background: bgColor, color: foreColor }}
                >
                  <div className="statistics-row">
                    <div className="one">
                      <div>
                        {intl.get('View')} {view}
                      </div>
                    </div>
                  </div>
                </div>
              ) : null}
              {/*<Lock />*/}
            </div>
          </div>
        </div>
      </div>
      <div
        className={'type2-name'}
        style={{ /*width: width,*/ color: h1Color }}
      >
        {desc}
      </div>
    </div>
  );

  // return (
  //   <div className={`videolist-item type2`} onClick={onClick}>
  //     <div className="photo">
  //       <img
  //         src={
  //           thumb
  //             ? direct(thumb, 'wx_gallery_mode_2')
  //             : require('../../assets/pic-bg.png')
  //         }
  //       />
  //       {info && status === IGalleryStatus.complete ? (
  //         <div className="status-complete-mask">
  //           {intl.get('VideoPlaybackGenerating')}
  //         </div>
  //       ) : null}
  //       {info ? (
  //         <div className="status-position">
  //           <StatusTag
  //             status={status as IGalleryStatus}
  //             className={'status'}
  //             invert={false}
  //             fontSize={12}
  //           />
  //         </div>
  //       ) : null}
  //       {info ? (
  //         <div
  //           className="count"
  //           style={{ background: bgColor, color: foreColor }}
  //         >
  //           <span>{intl.get('View')}</span>
  //           <span style={{ color: foreColor }}> {view}</span>
  //         </div>
  //       ) : null}
  //     </div>
  //     <div className="info">
  //       <div className="desc" style={{ color: h1Color }}>
  //         {desc}
  //       </div>
  //     </div>
  //   </div>
  // );
};
